var _ellipse, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewSession(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 82 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.0465,
    cy: 50.1828,
    rx: 25.2496,
    ry: 25.0191,
    fill: "#e5e3f8",
    fillOpacity: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5476 35.119C43.5476 34.3432 42.9187 33.7143 42.1429 33.7143C41.367 33.7143 40.7381 34.3432 40.7381 35.119V42.1429C40.7381 42.5154 40.8861 42.8727 41.1495 43.1362L43.9591 45.9457C44.5077 46.4943 45.3971 46.4943 45.9457 45.9457C46.4943 45.3971 46.4943 44.5077 45.9457 43.9591L43.5476 41.561V35.119Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4524 1.40476C15.4524 0.628933 14.8234 0 14.0476 0C13.2718 0 12.6429 0.628933 12.6429 1.40476V5.61905H8.42857C3.7736 5.61905 0 9.39265 0 14.0476V47.7619C0 52.4169 3.7736 56.1905 8.42857 56.1905H32.8214C35.4913 57.9657 38.6963 59 42.1429 59C51.4528 59 59 51.4528 59 42.1429C59 38.6963 57.9657 35.4913 56.1905 32.8214V14.0476C56.1905 9.39265 52.4169 5.61905 47.7619 5.61905H43.5476V1.40476C43.5476 0.628933 42.9187 0 42.1429 0C41.367 0 40.7381 0.628933 40.7381 1.40476V5.61905H15.4524V1.40476ZM25.2857 42.1429C25.2857 46.4603 26.9088 50.3986 29.5781 53.381H8.42857C5.32526 53.381 2.80952 50.8652 2.80952 47.7619V14.0476C2.80952 10.9443 5.32526 8.42857 8.42857 8.42857H12.6429V12.6429C12.6429 13.4187 13.2718 14.0476 14.0476 14.0476C14.8234 14.0476 15.4524 13.4187 15.4524 12.6429V8.42857H40.7381V12.6429C40.7381 13.4187 41.367 14.0476 42.1429 14.0476C42.9187 14.0476 43.5476 13.4187 43.5476 12.6429V8.42857H47.7619C50.8652 8.42857 53.381 10.9443 53.381 14.0476V29.5781C50.3986 26.9088 46.4603 25.2857 42.1429 25.2857C32.8329 25.2857 25.2857 32.8329 25.2857 42.1429ZM42.1429 56.1905C49.9011 56.1905 56.1905 49.9011 56.1905 42.1429C56.1905 34.3846 49.9011 28.0952 42.1429 28.0952C34.3846 28.0952 28.0952 34.3846 28.0952 42.1429C28.0952 49.9011 34.3846 56.1905 42.1429 56.1905Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewSession);
export default __webpack_public_path__ + "static/media/new-session.8d3896b1efe0ae196d9fdce53b47e9e7.svg";
export { ForwardRef as ReactComponent };